import { useSettingStore } from '@/stores/settingStore.js';

const unitDict = {
    'mm': { unit: 'in', conversion: 0.03937007874 },
    'm': { unit: 'ft', conversion: 3.28084 },
    'm²': {unit: 'f²', conversion: 10.7639},
    'm³/s': { unit: 'ft³/s', conversion: 35.3147 },
    'km': { unit: 'mi', conversion: 0.621371 },
    'Km²': { unit: 'mi²', conversion: 0.386102 },
    'kg/m³': { unit: 'lb/ft³', conversion: 0.062528 },
    'in': { unit: 'mm', conversion: 25.4 },
    'ft³/s': { unit: 'm³/s', conversion: 0.0283168 },
}

/**
 * Take a metric value and either return it or its imperial equivalent depending on user settings
 * @param x numeric value
 * @param unit type of unit in metric
 * @returns numeric value which is converted into the users unit choice
 */
export const convertValue = (x, unit) => {
    const settingStore = useSettingStore();
    if (settingStore.unitPreference === 'Metric') return +x;
    return x * unitDict[unit]['conversion'];
}

/**
 * Provide imperial unit counterpart when user has imperial units selected
 * @param unit metric unit
 * @returns metric or imperial unit depending on user settings
 */
export const convertUnit = (unit) => {
    const settingStore = useSettingStore();
    if (settingStore.unitPreference === 'Metric') return unit;
    return unitDict[unit]['unit'];
}

export const addCommas = (str) => {
    const parts = (str + "").split(".");
    let main = parts[0],
        len = main.length,
        output = "",
        first = main.charAt(0),
        i;

    if (first === '-') {
        main = main.slice(1);
        len = main.length;
    } else {
        first = "";
    }
    i = len - 1;
    while(i >= 0) {
        output = main.charAt(i) + output;
        if ((len - i) % 3 === 0 && i > 0) {
            output = "," + output;
        }
        --i;
    }
    // put sign back
    output = first + output;
    // put decimal part back
    if (parts.length > 1) {
        output += "." + parts[1];
    }
    return output;
}

export const getOffset = (date = new Date()) => {
    const settingStore = useSettingStore();
    const utcDate = new Date(date.toLocaleString('en-US', { timeZone: 'UTC' }));
    const tzDate = new Date(date.toLocaleString('en-US', { timeZone: settingStore.timezone || '' }));
    return (tzDate.getTime() - utcDate.getTime()) / 36e5;
};